/* HelloSpicy — scripts extraits de sections/hs-recette.liquid (audit A23 : sortis du HTML pour l'alléger et les mettre en cache). */
(function(){
        var flottant = document.querySelector('[data-hs-recette-flottant]');
        var ancre    = document.querySelector('[data-hs-recette-ancre]');
        if (!flottant || !ancre) return;
        if (!('IntersectionObserver' in window)) return;

        // Desktop uniquement : en mobile c'est hs-sticky-cta (barre du bas) qui
        // joue ce rôle. Le CSS masque déjà le flottant sous 990px ; ce garde-fou
        // JS évite en plus de faire tourner un observer pour rien.
        var mq = window.matchMedia('(min-width: 990px)');
        var obs = null;

        function afficher(v){ flottant.hidden = !v; }

        function activer(){
          if (obs) return;
          obs = new IntersectionObserver(function(entrees){
            var e = entrees[0];
            // RÉVISION 4a — le flottant apparaît dès que la RECETTE commence,
            // c'est-à-dire dès que la grille entre dans le viewport, et reste
            // ensuite visible. `isIntersecting` couvre l'entrée et la traversée ;
            // `top < 0` couvre la suite de la page, une fois la grille dépassée
            // (astuce, contenu restant), où l'observer ne rapporte plus
            // d'intersection.
            var commencee = e.isIntersecting || e.boundingClientRect.top < 0;
            afficher(commencee);
          });
          obs.observe(ancre);
        }

        function desactiver(){
          if (obs){ obs.disconnect(); obs = null; }
          afficher(false);
        }

        function maj(){ if (mq.matches) { activer(); } else { desactiver(); } }

        if (mq.addEventListener) { mq.addEventListener('change', maj); }
        else if (mq.addListener) { mq.addListener(maj); }
        maj();
      })();
